import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'auth-resetpwdsuccess',
    templateUrl: './resetpasswordsuccess.component.html'
})
export class ResetPasswordSuccessComponent {

}
